import { render, staticRenderFns } from "./Registradora.vue?vue&type=template&id=993c20f6&scoped=true"
import script from "./Registradora.vue?vue&type=script&lang=js"
export * from "./Registradora.vue?vue&type=script&lang=js"
import style0 from "./Registradora.vue?vue&type=style&index=0&id=993c20f6&prod&lang=scss"
import style1 from "./Registradora.vue?vue&type=style&index=1&id=993c20f6&prod&scoped=true&lang=css"
import style2 from "./Registradora.vue?vue&type=style&index=2&id=993c20f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993c20f6",
  null
  
)

export default component.exports